/**
 * Template: Gift card
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Gift Card template.
 *
 */
import {on} from '~/helpers/utils';

document.addEventListener('DOMContentLoaded', () => {

  /**
   * DOM selectors.
   */
  const selectors = {
    qrCode: '#QrCode',
    printButton: '#PrintGiftCard',
    code: '[js-gift-card="code"]',
  };

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    code: document.querySelector(selectors.code),
    printButton: document.querySelector(selectors.printButton),
  };

  if (nodeSelectors.printButton) {
    on('click', nodeSelectors.printButton, () => {
      window.print();
    });
  }

  if (nodeSelectors.code) {
    on('click', nodeSelectors.code, (event) => {
      event.currentTarget.select();
      document.execCommand('copy');
      event.currentTarget.blur();

      window.alert('Copied gift card code to clipboard');
    });
  }
});
